<template>
  <div class="modal fade" :id="modalId">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">

        <!-- Popup header -->
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">&times;</span>
            <span class="sr-only">Close</span>
          </button>
          <h4 class="modal-title" id="myModalLabel">
            Influencer Activation
          </h4>
        </div>

        <!-- Popup content -->
        <div class="modal-body row" v-if="user != null">
          <!-- Form -->

          <!-- First Name -->
          <div
            class="form-group col-xs-12 col-sm-6"
          >
            <label>First name</label>
            <p>{{user.firstName}}</p>
          </div>

          <!-- Last Name -->
          <div
            class="form-group col-xs-12 col-sm-6"
          >
            <label>Last name</label>
            <p>{{user.lastName}}</p>
          </div>

          <!-- Email -->
          <div
            class="form-group col-xs-12 col-sm-6"
          >
            <label>Email</label>
            <p>{{user.email}}</p>
          </div>

          <!-- Activate -->
          <div
            class="form-group col-xs-12 col-sm-6"
          >
            <label>Account Activation</label>
            <p>
              <b-button v-show="user.activated == null || user.activated == 1" disabled variant="secondary">Activated</b-button>
              <b-button v-show="user.activated != null && user.activated != 1" variant="success" @click="user.activated = 1">Activate Now</b-button>
            </p>
          </div>
        </div>

        <!-- Footer -->
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal" ref="closeButton">Close</button>
          <button type="button" class="btn btn-primary" @click="editUser">Save changes</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userAPIs from './userAPIs'

export default {
  name: 'ConfirmUserModal',
  props: [
    'modalId',
    'userData'
  ],
  data () {
    return {
      user: null
    }
  },
  watch: {
    userData: function (newUserData) {
      this.user = newUserData
    }
  },
  methods: {
    editUser: function () {
      const editingUser = {
        id: this.user.id,
        firstName: this.user.firstName,
        lastName: this.user.lastName,
        email: this.user.email,
        activated: this.user.activated
      }

      // Edit User
      userAPIs.editUser(editingUser)
        .then(response => {
          // Return the newly added data to parent component
          this.$emit('editUser', response)

          // Dismiss modal by triggering the click event on Close button
          this.$refs.closeButton.click()
        })
        .catch(error => {
          // Request failed.
          console.log('error', error)
        })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// ConfirmUserModal.vue?9a87f75e